/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerComponents } from "../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../shared/context/PlayerTranslationContext";
import PlayIcon from "../../../shared/icons/player/Play.svg";
import { usePlayerController } from "../../BasePlayer";
import { usePlayerLoadingState } from "../../Controller";

import "./BigPlayButton.scss";

export const BigPlayButton = () => {
  const { player } = usePlayerController();
  const { isLoading } = usePlayerLoadingState();
  const { Button } = usePlayerComponents();
  const { t } = usePlayerTranslation();

  const onClick = () => player.play();
  const label = t("PLAYER_TOOLTIP_PLAY");

  return (
    <>
      {!isLoading && (
        <Button
          variant="secondary"
          className="BigPlayButton"
          onClick={onClick}
          aria-label={label}
          iconOnly
        >
          <PlayIcon aria-hidden="true" focusable="false" />
        </Button>
      )}
    </>
  );
};
